import { useNavigate  } from 'react-router-dom';

import '../css/categorySection.css';
import arredamento from '../images/category/arredamento.png';
import soprammobili from '../images/category/soprammobili.png';
import elettrodomestici from '../images/category/elettrodomestici.png';
import tecnologia from '../images/category/tecnologia.png';
import giochi from '../images/category/giochi.png';
import vestiti from '../images/category/vestiti.png';
import libri from '../images/category/libri.png';
import attrezziSportivi from '../images/category/attrezzi_sportivi.png';
import attrezziDaLavoro from '../images/category/attrezzi_da_lavoro.png';

const CategorySection = () => {

    const navigate = useNavigate();

    const linkTo = (link) => {
        navigate(`/categoryPage/${link}`)
    }

    return (
        <div className='category-container'>
            <h3>Scegli per categoria</h3>
            <div className="category-section">
                    <div className="category-box" onClick={() => linkTo('Arredamento')}>
                        <div className="category-photo">
                            <img src={arredamento} />
                        </div>
                        <div className="category-info">Arredamento</div>
                    </div>
                    <div className="category-box" onClick={() => linkTo('Soprammobili')}>
                        <div className="category-photo">
                            <img src={soprammobili} />
                        </div>
                        <div className="category-info">Soprammobili</div>
                    </div>
                    <div className="category-box" onClick={() => linkTo('Elettrodomestici')}>
                        <div className="category-photo">
                            <img src={elettrodomestici} />
                        </div>
                        <div className="category-info">Elettrodomestici</div>
                    </div>
                    <div className="category-box" onClick={() => linkTo('Tecnologia')}>
                        <div className="category-photo">
                            <img src={tecnologia} />
                        </div>
                        <div className="category-info">Tecnologia</div>
                    </div>
                    <div className="category-box" onClick={() => linkTo('Giochi')}>
                        <div className="category-photo">
                            <img src={giochi} />
                        </div>
                        <div className="category-info">Giochi</div>
                    </div>
                    <div className="category-box" onClick={() => linkTo('Vestiti')}>
                        <div className="category-photo">
                            <img src={vestiti} />
                        </div>
                        <div className="category-info">Vestiti</div>
                    </div>
                    <div className="category-box" onClick={() => linkTo('Libri')}>
                        <div className="category-photo">
                            <img src={libri} />
                        </div>
                        <div className="category-info">Libri</div>
                    </div>
                    <div className="category-box" onClick={() => linkTo('Attrezzi sportivi')}>
                        <div className="category-photo">
                            <img src={attrezziSportivi} />
                        </div>
                        <div className="category-info">Attrezzi sportivi</div>
                    </div>
                    <div className="category-box" onClick={() => linkTo('Attrezzi da lavoro')}>
                        <div className="category-photo">
                            <img src={attrezziDaLavoro} />
                        </div>
                        <div className="category-info">Attrezzi da lavoro</div>
                    </div>
            </div>
        </div>
    )
}

export default CategorySection;